import { useState } from "react";
import { PatientApi } from "../../api";
import CircularProgress from "../CircleProgress";
import "./AddPatient.css";
import SecureStorage from "react-secure-storage";
const AddPatient = ({
  state,
  handleClose,
  doctorId,
  onPatientCreated,
  goToMain,
}) => {
  const [patientCode, setPatientCode] = useState("");
  const [loading, setLoading] = useState(false);
  if (!state) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleCancel = () => {
    setPatientCode("");
    handleClose();
  };

  const handleCreate = async () => {
    if (!patientCode.trim()) {
      alert("환자 코드를 입력해주세요.");
      return;
    }
    if(SecureStorage.getItem("createdPatientCode")){
      alert("완료 되지 않은 환자가 있습니다. 완료 후 다시 시도해주세요.");
      return;
    }
    // setLoading(true);
    try {
      const response = await PatientApi.createPatient({
        doctorId: doctorId,
        patientCode: patientCode,
      });
      if (response) {
        setLoading(false);
        const createdPatientCode = patientCode;
        setPatientCode("");
        handleClose();
        // Main에 환자 코드 전달
        if (onPatientCreated) {
          SecureStorage.setItem("createdPatientCode", createdPatientCode);
          onPatientCreated(createdPatientCode);
        }
      } else {
        setLoading(false);
        setPatientCode("");
        alert("이미 중복된 환자 입니다.");
      }
    } catch (error) {
      console.error("환자 생성 오류:", error);
      handleClose();
      setLoading(false);
      alert("환자 생성에 실패했습니다.");
    }
  };

  return (
    <div className="add-patient-modal-overlay" onClick={handleBackdropClick}>
      <div className="add-patient-modal-content">
        <div className="add-patient-modal-body">
          <h2 className="add-patient-modal-title">환자 코드를 입력해주세요.</h2>
          <input
            type="text"
            className="add-patient-modal-input"
            placeholder="환자 코드 입력"
            value={patientCode}
            onChange={(e) => setPatientCode(e.target.value)}
            onKeyPress={(e) => {
              if (e.key === "Enter") {
                handleCreate();
              }
            }}
          />
          <div className="add-patient-modal-buttons">
            <button
              className="add-patient-modal-button add-patient-modal-button-cancel"
              onClick={handleCancel}
              type="button"
              disabled={loading}
            >
              취소
            </button>
            <button
              className="add-patient-modal-button add-patient-modal-button-create"
              onClick={handleCreate}
              type="button"
              disabled={loading}
            >
              {loading ? (
                <CircularProgress color="white" thickness={4} size={20} />
              ) : (
                <div>등록</div>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPatient;
